import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConfirmAccountComponent } from './components/confirm-account/confirm-account.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SignInPageComponent } from './components/sign-in-page/sign-in-page.component';
import { VerifiedEmailPageComponent } from './components/verify-email/verified-email.component';
import { SignInGuard } from './guards/sign-in-guard.service';
import { LandingComponent } from './landing/landing.component';
import { EmailVerificationResolverService } from './services/email-verification-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
  },
  {
    path: 'sign-in',
    component: SignInPageComponent,
    canActivate: [SignInGuard],
  },
  {
    path: 'confirmAccount',
    component: ConfirmAccountComponent,
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent,
  },
  {
    path: 'verifyEmail/:verificationCode',
    component: VerifiedEmailPageComponent,
    resolve: {
      profile: EmailVerificationResolverService,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SigninRoutingModule {}
